import { EnumOption } from "./enum-option"

export const VisaBulletinDateType = {
    FamilySponsoredDatesFinalAction: 0,
    FamilySponsoredDatesForFiling: 1,
    EmploymentDatesFinalAction: 2,
    EmploymentBasedDatesForFiling: 3,
}

export const VisaBulletinDateTypeList: EnumOption[] = [
    { value: VisaBulletinDateType.FamilySponsoredDatesFinalAction, label: 'Family Sponsored Dates Final Action' },
    { value: VisaBulletinDateType.FamilySponsoredDatesForFiling, label: 'Family Sponsored Dates for Filing' },
    { value: VisaBulletinDateType.EmploymentDatesFinalAction, label: 'Employment Dates Final Action' },
    { value: VisaBulletinDateType.EmploymentBasedDatesForFiling, label: 'Employment Based Dates for Filing' },
]